<template>
  <app-modal
    :titulo="titulo"
    :width="width"
    :closeOutside="true"
    @closeModal="$emit('closeModal')"
  >
    <template slot="body">
      <el-carousel
        v-if="documentos"
        :loop="carouselConfig.loop"
        :height="carouselConfig.height"
        :autoplay="carouselConfig.autoplay"
        :trigger="carouselConfig.trigger"
        :arrow="carouselConfig.arrow"
        :indicator-position="carouselConfig.indicatorPosition"
        @change="changePdf"
      >
        <el-carousel-item
          v-for='documento in documentos'
          :key='documento.id'
          v-if="documento.bytes"
        >
          <component :is="componentViewer" :bytes="documento.bytes"/>
        </el-carousel-item>
      </el-carousel>
    </template>
    <template slot="footer">
      <div class="flex-end">
        <el-button @click="downloadDocument">
          <i class="fal fa-file-pdf"></i>
          <span>Exportar {{ isPdf ? 'PDF' : 'imagem' }}</span>
        </el-button>
      </div>
    </template>
  </app-modal>
</template>

<script>
import AppModal from '@/components/AppModal'
import AppPdfViewer from '@/components(new)/UI/Modals/VisualizarDocumentos/PdfViewer/PdfViewer'
import FileHelper from '@/utils/fileHelper'
import AppImageViewer from '@/components(new)/UI/Modals/VisualizarDocumentos/ImageViewer/ImageViewer'
import { base64ToBytes } from '@/libs/utils/functions/base64'

export default {
  components: {
    AppModal,
    AppPdfViewer,
    FileHelper,
    AppImageViewer
  },

  data () {
    return {
      documentoAtual: null
    }
  },

  props: {
    width: {
      type: Number,
      default: window.innerWidth * 0.85
    },
    titulo: {
      type: String,
      default: 'Visualizar Documento(s)'
    },
    documentos: {
      required: true,
      type: Array,
      validator (value) {
        if (!Array.isArray(value)) {
          return false
        }

        return value.every(item => {
          if (!item) {
            return false
          }
          const isByteArrayOrString = typeof item.bytes === 'string' || item.bytes instanceof ArrayBuffer
          return item.id && isByteArrayOrString
        })
      }
    },
    carouselConfig: {
      default: () => ({
        loop: false,
        height: '550px',
        autoplay: false,
        trigger: 'click',
        arrow: 'always',
        indicatorPosition: 'none'
      }),
      type: Object
    }
  },

  created () {
    this.changePdf(0)
  },

  computed: {
    isPdf () {
      return this.documentoAtual && (this.documentoAtual.extensao === 'pdf' || !this.documentoAtual.extensao)
    },
    componentViewer () {
      return this.isPdf ? 'app-pdf-viewer' : 'app-image-viewer'
    }
  },

  methods: {
    async downloadDocument () {
      FileHelper.saveFile(
        (this.documentoAtual.bytes instanceof ArrayBuffer ? this.documentoAtual.bytes : base64ToBytes(this.documentoAtual.bytes)),
        (this.documentoAtual.nome || this.titulo)
      )
    },
    changePdf (index) {
      this.documentoAtual = this.documentos[index]
    }
  }
}
</script>

<style scoped lang="scss">
  @import './styles.scss';
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizarDocumentos/VisualizarDocumentos.vue